"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserSettingsHaveLoaded = exports.getUserSettings = void 0;

var _Constants = require("../Constants");

var getUserSettings = function getUserSettings(state) {
  return state.userSettings;
};

exports.getUserSettings = getUserSettings;

var getUserSettingsHaveLoaded = function getUserSettingsHaveLoaded(state) {
  return _Constants.COMPLETED_REQUEST_STATUSES.includes(state.userSettings.get('status'));
};

exports.getUserSettingsHaveLoaded = getUserSettingsHaveLoaded;